<template>
  <div>
    <button
      class="btn btn-light border border-dark d-flex align-items-center gap-2 fw-bold shadow-sm py-1"
      type="button"
      data-bs-toggle="offcanvas"
      :data-bs-target="'#' + id"
      :aria-controls="id"
    >
      <i class="bi bi-list-task fs-5"></i>
      <div>{{ title }}</div>
    </button>

    <div
      class="offcanvas offcanvas-start"
      tabindex="-1"
      :id="id"
      :aria-labelledby="id + 'Label'"
    >
      <div class="offcanvas-header border-bottom">
        <h5 class="offcanvas-title fw-bold" :id="id + 'Label'">
          {{ title }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OffcanvasWrapper",
  props: {
    title: {
      type: String,
      default: "Offcanvas Title"
    },
    id: {
      type: String,
      default: "offcanvas"
    }
  }
};
</script>
